<template>
    <b-modal v-model="showFlg"
        size="lg"
        header-bg-variant="light"
        :title="headerTitle" 
        no-close-on-backdrop>
        <b-container fluid>
            <div>
                <template v-if="osTitle != null">
                    <div>
                        <p>
                            <img src="../img/icons/news_icon.gif">
                            <b class="ml-1">{{osTitle}}</b>
                        </p>
                    </div>
                </template>
                    
                <template v-if="osNaiyou != null">
                    <div>
                        <p v-html="osNaiyou"></p>
                    </div>
                </template>

                <template v-if="pt090Detail.length == 0">
                    <p>
                        {{strErrMsg}}
                    </p>
                </template>
            </div>
        </b-container>
        <div slot="modal-footer" class="text-center">
            <button class="btn btn-sm btn-secondary" @click="showFlg = false">{{$t('common.buttons.close')}}</button>
        </div>
    </b-modal>
</template>

<script>
/* 
* Import libs and componnents
*/
import common from "assets/js/common";
import axios from "assets/js/request";

export default {
    /* 
    * Name of component
    */
    name: "PT090InformationPartDetail",
    /* 
    * Get data from parent component
    */
    props: {
        request: {
            type: Object,
        }
    },
    /* 
    * Declare variable and set default value
    */
    data() {
        return {
            showFlg: true,
            pt090Detail: {
                
            },
            osTitle:null,
            osNaiyou:null,
            strErrMsg:null,
            storeTitleFlg: 0,
            ecOpenFlg: 0,
            headerTitle: null
        }
    },
    /*
    * Function watch
    */
    watch: {
        /*
        *  event close modal
        */
        showFlg(newVal, oldVal) {
            if (oldVal) {
               this.$emit('closed');
            }   
        }
    },
    /* 
    * Initialize
    */
    mounted() {
        var _this = this;
        axios
        .post(_this.$UrlConstants.ECSITE +_this.$UrlConstants.PT090 + _this.$UrlConstants.DO_INIT, _this.request)
        .then(function(response) {
            _this.osTitle = response.data.osTitle;
            _this.osNaiyou = response.data.osNaiyou;
            _this.strErrMsg = response.data.strErrMsg;
            _this.pt090Detail = response.data.osiraseOne;
            _this.storeTitleFlg = response.data.storeTitleFlg;
            _this.ecOpenFlg = response.data.ecOpenFlg;
            // メーカー、店舗タイトル利用フラグ
            if (_this.storeTitleFlg == 1) {
                // お知らせ限定フラグ
                if (_this.ecOpenFlg == 1) {
                    _this.headerTitle = _this.$i18n.t('pt090.labels.store') + _this.$i18n.t('pt090.labels.title');
                } else {
                    _this.headerTitle = _this.$i18n.t('pt090.labels.comp') + _this.$i18n.t('pt090.labels.title');
                }
            } else {
                _this.headerTitle = _this.$i18n.t('pt090.labels.title');
            }
        })
        .catch(function(error) {
            common.errorAPI(error);
        });
    },
}
</script>
